import { useState, useEffect } from 'react';
import HeadingAndIcon from '../../components/HeadingAndIcon/HeadingAndIcon';
import TabSelector from '../../components/TabSelector/TabSelector';
import styles from './AttendanceDetailsSection.module.css';
import { CiCalendar } from 'react-icons/ci';
import AttendanceDetails from '../../components/AttendanceDetails/AttendanceDetails';
import { useDispatch } from 'react-redux';
import { openModal } from '../../redux/slices/modalSlice';
import { useSelector } from 'react-redux';

const AttendanceDetailsSection = () => {
  const dispatch = useDispatch();
  const isModalOpen = useSelector((state) => state.modal.isOpen);
  const [activeLocationTab, setActiveLocationTab] = useState('Center');

  useEffect(() => {
    if (!isModalOpen && activeLocationTab === 'Room') {
      setActiveLocationTab('Center');
    }
  }, [isModalOpen]);

  const [dynamicData, setDynamicData] = useState({
    attendanceViewTabs: [{ label: 'Center' }, { label: 'Room' }],
    rowDataList: {
      Students: [
        { room: 'Room 1', in: '05', out: '02', pending: '02' },
        { room: 'Room 2', in: '02', out: '02', pending: '02' },
        { room: 'Room 1', in: '05', out: '02', pending: '02' },
        { room: 'Room 2', in: '02', out: '02', pending: '02' },
        { room: 'Room 1', in: '05', out: '02', pending: '02' },
        { room: 'Room 2', in: '02', out: '02', pending: '02' },
        { room: 'Room 1', in: '05', out: '02', pending: '02' },
        { room: 'Room 2', in: '02', out: '02', pending: '02' },
        { room: 'Room 1', in: '05', out: '02', pending: '02' },
        { room: 'Room 2', in: '02', out: '02', pending: '02' },
        { room: 'Room 1', in: '05', out: '02', pending: '02' },
        { room: 'Room 2', in: '02', out: '02', pending: '02' },
        { room: 'Room 1', in: '05', out: '02', pending: '02' },
        { room: 'Room 2', in: '02', out: '02', pending: '02' },
      ],
      Staff: [
        { room: 'Room A', in: '01', out: '00', pending: '00' },
        { room: 'Room B', in: '03', out: '01', pending: '01' },
        { room: 'Room A', in: '01', out: '00', pending: '00' },
        { room: 'Room B', in: '03', out: '01', pending: '01' },
        { room: 'Room A', in: '01', out: '00', pending: '00' },
        { room: 'Room B', in: '03', out: '01', pending: '01' },
        { room: 'Room A', in: '01', out: '00', pending: '00' },
        { room: 'Room B', in: '03', out: '01', pending: '01' },
        { room: 'Room A', in: '01', out: '00', pending: '00' },
        { room: 'Room B', in: '03', out: '01', pending: '01' },
        { room: 'Room A', in: '01', out: '00', pending: '00' },
        { room: 'Room B', in: '03', out: '01', pending: '01' },
        { room: 'Room A', in: '01', out: '00', pending: '00' },
        { room: 'Room B', in: '03', out: '01', pending: '01' },
      ],
    },
    totalStudentsToday: 0,
    totalStaffToday: 0,
    roomStaffStatus: 'N/A',
  });

  useEffect(() => {
    if (activeLocationTab === 'Room') {
      dispatch(
        openModal({
          type: 'attendanceRoom',
          data: dynamicData.rowDataList,
        })
      );
    }
  }, [activeLocationTab, dispatch, dynamicData.rowDataList]);

  const renderMainContent = () => {
    if (activeLocationTab === 'Center') {
      return (
        <div className={styles.CenterAttendanceGrid}>
          <AttendanceDetails
            title="Students present Today"
            total={dynamicData.totalStudentsToday}
            statuses={[
              { label: 'In', value: 99999 },
              { label: 'Out', value: 99999 },
              { label: 'Pending', value: 99999 },
            ]}
          />
          <div className={styles.VerticalDivider}></div>
          <AttendanceDetails
            title="Staff present Today"
            total={dynamicData.totalStaffToday}
            statuses={[
              { label: 'In', value: 99999 },
              { label: 'Out', value: 99999 },
              { label: 'Pending', value: 99999 },
            ]}
          />
        </div>
      );
    }

    return null; // No content for "Room" here, handled in modal
  };

  return (
    <div className={styles.AttendanceDetailsSection}>
      <div className={styles.SectionHeader}>
        <HeadingAndIcon
          heading={'Attendance'}
          icon={
            <CiCalendar
              className={styles.icon}
              size={20}
              style={{ color: 'var(--Primary_Color)' }}
            />
          }
        />
        <div className={styles.HeaderRightPart}>
          <TabSelector
            options={dynamicData.attendanceViewTabs}
            activeTab={activeLocationTab}
            setActiveTab={setActiveLocationTab}
          />
        </div>
      </div>
      <div className={styles.MainSection}>{renderMainContent()}</div>
    </div>
  );
};

export default AttendanceDetailsSection;
